/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Option } from './option';
import { QuestionTypeEnum } from './question-type-enum';


/**
 * options field is filled only if question_type is \'option\'
 */
export interface Question { 
    questionType: QuestionTypeEnum;
    options?: Array<Option>;
    value?: string | null;
    id?: number;
    uuid?: string;
    title: string;
    visibleTitle: boolean;
}

